export default "__VITE_ASSET__C8IJVi3g__"